import './IncrementalityPlaybook.scss';
import cn from 'classnames';
import { ReactElement, useState } from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import { CDN } from '@Components/MetricsTable/metrics-table-utils';
import { InteractiveDiv } from '@Components/InteractiveEl';

export const PAGE_PREFIX = `${window.location.origin}/incrementality-playbook`;

// Channel name → subpage names. Used by PlaybookTable to resolve navigation links
// without importing from IncrementalityPlaybook (which would create a cycle).
// null = channel exists but has no subpages; missing key = channel not known.
export const INC_CHANNEL_SUBPAGES: Record<string, string[] | null> = {
  'All Channels': ['Geo Testing'],
  Commerce: ['Amazon'],
  Display: ['Google (DV360)', 'The Trade Desk'],
  'Linear TV': null,
  'Multi-Channel': ['Discovery', 'Performance Max'],
  Search: ['Google Search'],
  Shopping: null,
  Social: ['Meta', 'Pinterest', 'Reddit', 'Snapchat', 'TikTok'],
  Streaming: ['Spotify', 'YouTube', 'Ghost Bidding']
};

export interface IncPlaybookNavPageData {
  icon?: ReactElement;
  subPages?: Record<string, unknown>;
}
export type IncPlaybookNavPagesData = Record<string, Record<string, IncPlaybookNavPageData>>;
export const INC_CDN = `${CDN}/incrementality`;

export const navigateToSection = (
  sectionID: string,
  behavior?: ScrollBehavior | undefined
): void => {
  const sectionElement = window.document.getElementById(sectionID);
  if (sectionElement) {
    if (!sectionElement.className.includes('expanded')) {
      const titleID = `${sectionID}_title`;
      const titleElement = window.document.getElementById(titleID);
      if (titleElement) {
        titleElement.click();
      }
    }
    sectionElement.scrollIntoView({ behavior });
  }
};

export interface IncPlaybookSectionBoxProps {
  className?: string;
  content: ReactElement;
  id?: string;
  pageTitle?: string;
  title: string;
}

export const IncPlaybookSectionBox = ({
  className = '',
  content,
  id,
  pageTitle,
  title
}: IncPlaybookSectionBoxProps) => {
  const [expanded, setExpanded] = useState<boolean>(true);

  return (
    <div className={cn('inc-playbook-section-box', { expanded }, className)} id={id}>
      <InteractiveDiv
        className='title-container'
        id={id ? `${id}_title` : undefined}
        onClick={() => setExpanded(!expanded)}
      >
        <div className='label-container'>
          <div className='section-title'> {title}</div>
          {Boolean(pageTitle) && (
            <>
              <div className='page-title'>|</div>
              <div className='page-title'> {pageTitle}</div>
            </>
          )}
        </div>
        <div className='icon-container'>
          {expanded ? <MdArrowForwardIos /> : <MdArrowBackIos />}
        </div>
      </InteractiveDiv>
      {expanded && (
        <div className='divider-line-container'>
          <div className='divider-line' />
        </div>
      )}
      {expanded && <div className='content-container'>{content}</div>}
    </div>
  );
};
